import emailjs from '@emailjs/browser';

interface EmailResponse {
  message: string;
  status: 'subscribed' | 'existing_member';
}

export async function addToMailingList(email: string, city: string): Promise<EmailResponse> {
  try {
    await emailjs.send(
      'service_5g4scsj',
      'template_ww7d5yq',
      {
        email: email,
        to_email: 'neilgreenhorn@gmail.com',
        subscription_type: 'Waitlist',
        date: new Date().toLocaleDateString(),
        city: city
      },
      'rawFkFq6FJXNNDvjB'
    );

    return {
      message: 'Successfully joined the waitlist!',
      status: 'subscribed'
    };
  } catch (error: any) {
    console.error('EmailJS error:', error);
    throw new Error('Failed to join waitlist. Please try again later.');
  }
}